import { Action } from 'redux';
import { isRefreshSessionInfoAction } from '../actions/RefreshSessionInfoAction';
import { SessionState } from '../state/SessionState';

export const InitialState: SessionState = {
  info: null
};

export function sessionReducer(
    previousState: SessionState = InitialState,
    action: Action = null
): SessionState {

  if (isRefreshSessionInfoAction(action) && action.sessionInfo) {
    return {
      ...previousState,
      info: action.sessionInfo
    };
  } else {
    return previousState;
  }
}
